import React from "react"
import { AiOutlineCloseCircle } from "react-icons/ai"
import { BiTrash } from "react-icons/bi"
import { BsTrash2 } from "react-icons/bs"

const DeleteModal = ({
  handleDelete,
  showConfirmModal,
  setShowConfirmModal,
  loading,
  title,
  message,
}) => {
  return (


    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full max-w-[400px] p-4 relative">
        <button
          onClick={() => setShowConfirmModal(false)}
          className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <AiOutlineCloseCircle className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-yellow-main/10 rounded-full flex items-center justify-center mb-3">
            <div className="w-12 h-12 bg-yellowcolor/30 dark:bg-[#FEECB8] rounded-full flex items-center justify-center">
              <BiTrash className="h-8 w-8 text-yellow-500" />
            </div>
          </div>

          <h2 className="text-xl font-bold mb-2 dark:text-white">Confirm</h2>
          <p className="text-gray-600 text-sm dark:text-gray-400 mb-6">
            {message || `Are you sure you want to delete this ${title}?`}
          </p>

          <div className="flex gap-4 w-full">
            <button variant="outline" className="flex-1 h-12 border rounded-full border-lightGray2 dark:border-border-darkGray dark:text-white"
              onClick={() => setShowConfirmModal(false)}
              disabled={loading}
            >
              No
            </button>
            <button className="flex-1 h-12 rounded-full bg-yellow-400 hover:bg-yellow-500 text-black"
              onClick={() => {
                handleDelete()
              }}
              disabled={loading}
            >
              {loading ? "Please wait..." : "Yes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal
